export default __webpack_public_path__ + "static/cyberia-01ebe77c1f35fe0e5ce44eb86082644e.mp4";